module.exports = __webpack_public_path__ + "static/img/guarantee.8697166.png";


//////////////////
// WEBPACK FOOTER
// ./static/cooperate/guarantee.png
// module id = jICI
// module chunks = 1